import React from 'react'
import { Grid, Typography, useTheme } from '@material-ui/core';


interface Props {
    classNameOuterGrid?: string,
    classNameLabel?: string,
    classNameValue?: string,
    classNameAfterValue?: string,
    value: any,
    afterValue?: any,
    label: any,
    error?: boolean,
    errorLabel?: string
}

export default function GridResultRow(props: Props) {
    const theme = useTheme();

    return (
        <Grid container className={props.classNameOuterGrid}>
            <Grid className={props.classNameLabel} item xs={12} sm={8}>
                {props.label}

                {props.error ? <Typography style={{ fontSize: "0.7rem", color: theme.palette.error.main, marginTop: "-5px" }}>{props.errorLabel}</Typography> : ""}
            </Grid>
            <Grid item xs={12} sm={4}>
                <Grid container alignItems="flex-start" justify="flex-start" >
                    <Grid item className={props.classNameValue} xs={12}>
                        {props.value ? props.value : "0" }&nbsp;{ props.afterValue}                       
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}
